<template> 
<!-- Filter -->
    <div class="timeline-filter" id="timeline-filter-form">
        <div class="custom-select-box" v-on:click="selectBox" data-filter="diseasestate">
            <label class="label">Disease State</label>
            <span class="selected-option" data-filterType="data-diseasestate"></span>
            <ul>
                <li v-for="(disease, index) in allowedStates" v-on:click="setSelectedOption" class="select-option" :key="index">
                    {{ disease.name[0].value}}
                </li>
            </ul>
        </div>
        
        <div class="custom-select-box" v-on:click="selectBox" data-filter="product">
            <label class="label">Product</label>
            <span class="selected-option" data-filterType="data-product"></span>
            
            <ul>
                <li v-for="name in productNames" v-on:click="setSelectedOption" class="select-option" :key="name.nid[0].value" :data-product-id="name.nid[0].value" :data-product="name.title[0].value" :data-tid="htmlReplace(name.field_product_description[0].value)">
                    {{ name.title[0].value}}
                </li>
            </ul>
        </div>

        <div class="custom-select-box" v-on:click="selectBox" data-filter="phase">
            <label class="label">Phase</label>
            <span class="selected-option" data-filterType="data-phase"></span>
            <ul>
                <li v-for="phase in phases" v-on:click="setSelectedOption" class="select-option" :key="phase.tid[0].value">
                    {{ phase.name[0].value }}
                </li>
            </ul>
        </div>

        <button type="button" id="apply-filter" class="btn btn-primary" @click.prevent="applyFilters">Apply filter</button>
        &nbsp;&nbsp;
        <button type="button" id="clear-filter" class="btn btn-secondary" @click.prevent="removeFilters">Clear filters</button> 
    </div>
</template> 


<script>
    export default {
        name: 'Filters',
        data: function(){
            return {
                storeTextChange: false,
                modalProduct: '',
            }
        }, 
        computed: {
            productNames: function() {
                return this.$store.getters.getAllowedProducts;
            },
            phases: function() {
                return this.$store.getters.getPhases;
            }, 
            diseaseStates: function() {
                return this.$store.getters.getAllowedDiseaseStates;
            },
            allowedStates() {
                return this.allowedProduct()
            },
        },
        mounted: function(){
            if(this.$route.params.filtertype !== undefined){
                var filtertype = this.$route.params.filtertype; 
                var filtervalue = this.$route.params.filtervalue; 
                this.setFilterOnLoad(filtertype, filtervalue);  
            }
        },
        methods: {
            htmlReplace: function(str) {
                return str.replace(/<(?:.|\n)*?>/gm, '');
            },
            canDisplayProduct: function() {
                let productNames = this.$store.getters.getProductNames; 
                let notAllowedProducts = window.localStorage.getItem('storageProducts'); 
                if(notAllowedProducts == null) {
                    return productNames;
                }

                let filtered = productNames.filter(el => notAllowedProducts.indexOf(el.nid[0].value) < 0);  
            
                return filtered;

            },
            allowedProduct: function() {
                                
                var trials = this.$store.getters.allProducts; 
                var notAllowedItems = window.localStorage.getItem('storageProducts'); 
                let allowedStates = []; 
                
                if(notAllowedItems !== null){
                    var notAllowed = JSON.parse(notAllowedItems); 
                    let filtered = trials.filter( el => el.field_product_list && notAllowed.indexOf(el.field_product_list[0].target_id) < 0 );
                    
                    let pillars = []; 
                   
                    if(filtered.length > 0) {
                        filtered.forEach(function(filt){

                            let ds = filt.field_disease_state_tag; 
                            let dsLength = ds.length; 

                            for(let i = 0; i<dsLength; i++) {

                                pillars.push(ds[i].target_id); 
                            }
                        })
                    }

                    const distinct = (value, index, self) => {
                        return self.indexOf(value) === index; 
                    }

                    allowedStates = pillars.filter(distinct); 
                    let d = this.diseaseStates.filter( el => allowedStates.indexOf(el.tid[0].value.toString()) > -1); 
                    
                    return d;
                    
                } else {
                    return this.$store.getters.getDiseaseStates;
                }
               
            },
            selectBox: function(event){
                let timelineFilter = document.querySelector('.timeline-filter'); 
                let cur = event.currentTarget; 
                if(cur.classList.contains('active')){
                    cur.classList.remove('active'); 
                } else {
                    let allActive = timelineFilter.querySelectorAll('.active'); 
                    allActive.forEach(function(el){
                        el.classList.remove('active');
                    })

                    cur.classList.add('active'); 
                }
            },
            setSelectedOption: function(event) {
                let text = event.currentTarget.textContent; 
                let extraString; 

                let parent = event.currentTarget.closest('.custom-select-box'); 
                parent.classList.add('option-selected'); 

                let selectedOption = parent.querySelector('.selected-option');
                selectedOption.textContent = text; 

                if(parent.dataset.filter == 'product')
                {
                    extraString = event.currentTarget.dataset.tid; 
                    this.storeTextChange = text+' '+extraString;

                    this.modalProduct = event.currentTarget.dataset.product;
                }
            },
            deleteRouteQuery: function(type, value) {
                let query = Object.assign({}, this.$route.query);
                delete query[type];
                delete query[value]; 
                this.$router.replace({ query });
            },
            setFilterOnLoad: function(type, value) {
                
                    let parent = document.querySelector('[data-filter*="'+ type +'"]');
                    let apply = document.getElementById('apply-filter'); 

                    parent.classList.add('option-selected'); 
                    let textSpan = parent.querySelector('.selected-option');
                    textSpan.textContent = value;


                    if(this.$route.params.filtertype === 'product') {
                        this.modalProduct = value;
                    } else {
                        // Default to first available product so MoA button shows on all routes
                        let products = this.$store.getters.getProductNames;
                        this.modalProduct = (products && products.length > 0) ? products[0].title[0].value : false;
                    }

                    apply.click();


                
                //this.deleteRouteQuery(type, value); 
                
            },
            applyFilters: function() {
                
                let form = document.getElementById('timeline-filter-form'); 

                let options = form.querySelectorAll('.selected-option');



                let fields = [];
                let filterObj = [];
                let str = '';
                let hasProductFilter = false;
                options = [].slice.call(options);
                options.forEach(function(opt) {
                    if(opt.textContent != '') {
                        var d = window.$(opt).data('filtertype')

                        if (d === 'data-product') {
                            hasProductFilter = true;
                        }

                        if(d == 'data-phase'){
                            str += '['+d+'="'+ opt.innerHTML.trim() +'"]'; 
                        } else {
                            str += '['+d+'*="'+ opt.innerHTML.trim() +'"]'; 
                        }
                        fields.push( str );
                        filterObj.push(d);
                    }
                })




                if(!hasProductFilter) {
                    // Default to first available product so MoA button stays visible
                    let products = this.$store.getters.getProductNames;
                    this.modalProduct = (products && products.length > 0) ? products[0].title[0].value : false;
                }

                var allItems = document.querySelectorAll('.timeline-item');
                allItems = [].slice.call(allItems);
                allItems.forEach(function(el) {
                    el.hidden = true;
                })

                var matchedItems = document.querySelectorAll(str);
                matchedItems = [].slice.call(matchedItems)
                matchedItems.forEach(function(matches){
                    matches.hidden = false;
                })

                this.$emit('change', this.storeTextChange);
                this.$emit('updateModal', this.modalProduct);

                this.$emit('itemsChange', false);
            },
            removeFilters: function() {
                var allItems = document.querySelectorAll('.timeline-item'); 

                allItems.forEach(function(el) {
                    el.hidden = false; 
                })

                // Default to first available product so MoA button stays visible
                let products = this.$store.getters.getProductNames;
                this.modalProduct = (products && products.length > 0) ? products[0].title[0].value : '';
                this.$emit('updateModal', this.modalProduct);
                this.clearOptions(); 
            },
            clearOptions: function() {
                let selectBoxes = document.querySelectorAll('.custom-select-box'); 

                selectBoxes.forEach(function(boxes){
                    boxes.classList.remove('acitve');
                    boxes.classList.remove('option-selected');

                    boxes.querySelector('.selected-option').innerHTML = ''; 
                })

                this.$router.push({
                    path: '/timeline'
                })

                this.storeTextChange = false; 
                this.$emit('change', this.storeTextChange);
                this.$emit('itemsChange', true);
            }
        }
    }

</script>